var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56953 13.1359C4.31186 12.3936 5.31867 11.9766 6.36849 11.9766H12.7018C13.7516 11.9766 14.7585 12.3936 15.5008 13.1359C16.2431 13.8783 16.6602 14.8851 16.6602 15.9349V17.5182C16.6602 17.9555 16.3057 18.3099 15.8685 18.3099C15.4313 18.3099 15.0768 17.9555 15.0768 17.5182V15.9349C15.0768 15.305 14.8266 14.7009 14.3812 14.2555C13.9358 13.8101 13.3317 13.5599 12.7018 13.5599H6.36849C5.7386 13.5599 5.13451 13.8101 4.68911 14.2555C4.24371 14.7009 3.99349 15.305 3.99349 15.9349V17.5182C3.99349 17.9555 3.63905 18.3099 3.20182 18.3099C2.7646 18.3099 2.41016 17.9555 2.41016 17.5182V15.9349C2.41016 14.8851 2.82719 13.8783 3.56953 13.1359Z",
    fill: "#67768E",
    stroke: "#67768E",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53548 4.0599C8.22381 4.0599 7.16048 5.12322 7.16048 6.4349C7.16048 7.74657 8.22381 8.8099 9.53548 8.8099C10.8472 8.8099 11.9105 7.74657 11.9105 6.4349C11.9105 5.12322 10.8472 4.0599 9.53548 4.0599ZM5.57715 6.4349C5.57715 4.24877 7.34935 2.47656 9.53548 2.47656C11.7216 2.47656 13.4938 4.24877 13.4938 6.4349C13.4938 8.62102 11.7216 10.3932 9.53548 10.3932C7.34935 10.3932 5.57715 8.62102 5.57715 6.4349Z",
    fill: "#67768E",
    stroke: "#67768E",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.78bc522ad6b712660ce81794361b16c5.svg";
export { ForwardRef as ReactComponent };